/**
 * Iter 69 — Fire-and-forget conversion-widget event logger.
 *
 * Each of the 3 car-detail widgets calls `logWidgetEvent("widget_key",
 * "kind", car_id)` to record impressions and clicks. The endpoint is
 * fault-tolerant so we don't bother with error handling on the client.
 *
 * We deliberately bypass axios interceptors via `fetch` + `keepalive` so
 * the event survives a fast page-unload (clicking a row navigates away).
 */
import { API } from "./api";

const EMITTED_IMPRESSIONS = new Set();

export function logWidgetEvent(widget, kind, carId, detail = null) {
  if (!widget || !kind || !carId) return;
  // De-dupe impressions on the same (widget, carId) within a session — the
  // useEffect fires on every re-render of the form values otherwise.
  if (kind === "impression") {
    const key = `${widget}:${carId}`;
    if (EMITTED_IMPRESSIONS.has(key)) return;
    EMITTED_IMPRESSIONS.add(key);
  }
  try {
    fetch(`${API}/conversion-widgets/event`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ widget, kind, car_id: carId, detail }),
      credentials: "include",
      keepalive: true,
    }).catch(() => {});
  } catch (_e) { /* never break the page */ }
}
